import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { StatementPeriodMode } from "../../types/card-statement.types";

export interface StatementPeriodModeSwitchProps {
  value: StatementPeriodMode;
  onChange: (mode: StatementPeriodMode) => void;
  disabled?: boolean;
}

const MODES: StatementPeriodMode[] = [
  StatementPeriodMode.MONTH,
  StatementPeriodMode.RANGE,
  StatementPeriodMode.LIFETIME,
];

export const StatementPeriodModeSwitch = ({
  value,
  onChange,
  disabled = false,
}: StatementPeriodModeSwitchProps) => {
  const { t } = useTranslations("cards");

  const labels: Record<StatementPeriodMode, string> = {
    month: t("statement_mode_month"),
    range: t("statement_mode_range"),
    lifetime: t("statement_mode_lifetime"),
  };

  return (
    <div
      role="tablist"
      aria-label={t("statement_mode_aria")}
      className="inline-flex items-center gap-1 rounded-md bg-muted p-1"
    >
      {MODES.map((mode) => {
        const active = mode === value;
        return (
          <button
            key={mode}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange(mode)}
            className={cn(
              "rounded-sm px-3 py-1.5 text-xs font-medium transition-all",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              active ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            {labels[mode]}
          </button>
        );
      })}
    </div>
  );
};
